import React from "react";

export const operativnoLogoDark = () => (
    <svg
        width="160"
        height="25"
        viewBox="0 0 160 20"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
    >
        <text
            x="40%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="24"
            fill="#333333"
            fontFamily="Arial, sans-serif"
            fontWeight="bold"
        >
            regnews
        </text>
        <g transform="translate(160, 12)">
            <path
                d="M970 1425 l0 -65 -100 0 -100 0 0 -173 0 -173 65 -64 64 -64 3 170 3
        169 100 0 100 0 3 -105 3 -105 62 -62 c34 -35 65 -63 69 -63 4 0 8 75 8 167
        l0 166 -132 134 c-73 73 -136 133 -140 133 -4 0 -8 -29 -8 -65z"
                fill="#333333"
                transform="scale(0.03) translate(-1170, -1200) rotate(180, 700, 1120)"
            />
        </g>
    </svg>
);
